module.exports = "<p>\n  message-list-item works!\n</p>\n"